"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.breadcrumbItem = void 0;

var _stylitas = require("@creditas/stylitas");

const breadcrumbItem = ({
  theme
}) => (0, _stylitas.css)`
  color: ${_stylitas.utilities.palette.color(theme, 'secondary05')};
  text-decoration: underline;
  display: flex;
  align-items: center;
  font-weight: bold;

  &:not(:nth-last-of-type(2)) {
    ${(0, _stylitas.mq)({
  display: (0, _stylitas.mediaValue)('none', 'flex')
})}
  }

  &:last-of-type {
    text-decoration: none;

    ${(0, _stylitas.mq)({
  color: (0, _stylitas.mediaValue)(_stylitas.utilities.palette.color(theme, 'secondary05'), _stylitas.utilities.palette.color(theme, 'neutral07')),
  fontWeight: (0, _stylitas.mediaValue)('bold', 'normal')
})}

    svg {
      &:last-of-type {
        display: none;
      }
    }
  }

  svg {
    &:first-of-type {
      ${(0, _stylitas.mq)({
  display: (0, _stylitas.mediaValue)('block', 'none'),
  fill: (0, _stylitas.mediaValue)(_stylitas.utilities.palette.color(theme, 'secondary05'), 'none')
})}
    }

    &:last-of-type {
      ${(0, _stylitas.mq)({
  display: (0, _stylitas.mediaValue)('none', 'block')
})}
    }
  }
`;

exports.breadcrumbItem = breadcrumbItem;